<div class="mm04-force-direction__container">
    <sera-toggle-button
        toggleButtonStyleClass="sera-toggle-button--squared"
        [style]="{ position: 'absolute', right: '69%', top: '11%', 'margin-top': '-16px' }"
        [disabled]="readOnly"
        [unToggleable]="true"
        [onLabel]="MM04DirectionLabels.B_MINUS"
        [offLabel]="MM04DirectionLabels.B_MINUS"
        [ngModel]="isSelectedForceCaseDirection(MM04Direction.B_MINUS)"
        (stateChanged)="forceCaseDirectionChange(MM04Direction.B_MINUS)" />
    <sera-toggle-button
        toggleButtonStyleClass="sera-toggle-button--squared"
        [style]="{ position: 'absolute', right: '87.5%', top: '37%', 'margin-top': '-16px' }"
        [disabled]="readOnly"
        [unToggleable]="true"
        [onLabel]="MM04DirectionLabels.C_PLUS"
        [offLabel]="MM04DirectionLabels.C_PLUS"
        [ngModel]="isSelectedForceCaseDirection(MM04Direction.C_PLUS)"
        (stateChanged)="forceCaseDirectionChange(MM04Direction.C_PLUS)" />
    <sera-toggle-button
        toggleButtonStyleClass="sera-toggle-button--squared"
        [style]="{ position: 'absolute', left: '56.5%', top: '37%', 'margin-top': '-16px' }"
        [disabled]="readOnly"
        [unToggleable]="true"
        [onLabel]="MM04DirectionLabels.C_PLUS"
        [offLabel]="MM04DirectionLabels.C_PLUS"
        [ngModel]="isSelectedForceCaseDirection(MM04Direction.C_PLUS)"
        (stateChanged)="forceCaseDirectionChange(MM04Direction.C_PLUS)" />
    <sera-toggle-button
        toggleButtonStyleClass="sera-toggle-button--squared"
        [style]="{ position: 'absolute', right: '87.5%', top: '55%', 'margin-top': '-16px' }"
        [disabled]="readOnly"
        [unToggleable]="true"
        [onLabel]="MM04DirectionLabels.C_MINUS"
        [offLabel]="MM04DirectionLabels.C_MINUS"
        [ngModel]="isSelectedForceCaseDirection(MM04Direction.C_MINUS)"
        (stateChanged)="forceCaseDirectionChange(MM04Direction.C_MINUS)" />
    <sera-toggle-button
        toggleButtonStyleClass="sera-toggle-button--squared"
        [style]="{ position: 'absolute', left: '56.5%', top: '55%', 'margin-top': '-16px' }"
        [disabled]="readOnly"
        [unToggleable]="true"
        [onLabel]="MM04DirectionLabels.C_MINUS"
        [offLabel]="MM04DirectionLabels.C_MINUS"
        [ngModel]="isSelectedForceCaseDirection(MM04Direction.C_MINUS)"
        (stateChanged)="forceCaseDirectionChange(MM04Direction.C_MINUS)" />
    <sera-toggle-button
        toggleButtonStyleClass="sera-toggle-button--squared"
        [style]="{ position: 'absolute', right: '69%', bottom: '11%', 'margin-bottom': '-16px' }"
        [disabled]="readOnly"
        [unToggleable]="true"
        [onLabel]="MM04DirectionLabels.B_PLUS"
        [offLabel]="MM04DirectionLabels.B_PLUS"
        [ngModel]="isSelectedForceCaseDirection(MM04Direction.B_PLUS)"
        (stateChanged)="forceCaseDirectionChange(MM04Direction.B_PLUS)" />
    <sera-toggle-button
        toggleButtonStyleClass="sera-toggle-button--squared"
        [style]="{ position: 'absolute', right: '22.2%', bottom: '69%', 'margin-right': '-16px' }"
        [disabled]="readOnly"
        [unToggleable]="true"
        [onLabel]="MM04DirectionLabels.A_PLUS"
        [offLabel]="MM04DirectionLabels.A_PLUS"
        [ngModel]="isSelectedForceCaseDirection(MM04Direction.A_PLUS)"
        (stateChanged)="forceCaseDirectionChange(MM04Direction.A_PLUS)" />
    <sera-toggle-button
        toggleButtonStyleClass="sera-toggle-button--squared"
        [style]="{ position: 'absolute', right: '22.2%', top: '61%', 'margin-right': '-16px' }"
        [disabled]="readOnly"
        [unToggleable]="true"
        [onLabel]="MM04DirectionLabels.A_MINUS"
        [offLabel]="MM04DirectionLabels.A_MINUS"
        [ngModel]="isSelectedForceCaseDirection(MM04Direction.A_MINUS)"
        (stateChanged)="forceCaseDirectionChange(MM04Direction.A_MINUS)" />
    <img
        [ngClass]="{ 'mm04-force-direction__image': true, invalid: invalid }"
        src="assets/images/MM04/MM04_FORCE_CASE_DIRECTION.png" />
</div>
